import { RichTextTile } from "web/components/Tiles"
import { useTile } from "web/hooks/data"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import { TileRichTextSettingsModal } from "../TileRichTextSettingsModal"

export default function RichTextTileWrapper({
  canEdit,
  isTemplate,
  setIsDraggable,
  tileHeight,
  tileFetchParams,
  overview,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    isTemplate,
    overview,
    tileSettingsComponent: TileRichTextSettingsModal,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  if (isTemplate && tileFetchParams.routeSuffix === "rich_text_notes") {
    tile.body =
      "<span class='italic'>This tile can not be edited within a template.</span>"
  }

  return (
    <RichTextTile
      canEdit={canEdit}
      id={tileFetchParams.id}
      isEditable={
        isTemplate && tileFetchParams.routeSuffix !== "rich_text_notes"
      }
      setIsDraggable={setIsDraggable}
      tile={tile}
      tileHeight={tileHeight}
      tileSettingsModal={tileSettingsModal}
    />
  )
}
